// 近場の吉方位（車で20〜30分圏内）。日盤から方角と場所の種類だけを返し、固有名詞は出さない。

// getStarsFor() の並び（TodayTab の盤と同じ）
const POS_DIR = ['東南', '南', '西南', '東', '中', '西', '東北', '北', '西北'];
const OPP: Record<number, number> = { 0: 8, 1: 7, 2: 6, 3: 5, 5: 3, 6: 2, 7: 1, 8: 0 };
// 日の十二支（子=0）がある方角の位置
const BRANCH_POS = [7, 6, 6, 3, 0, 0, 1, 2, 2, 5, 8, 8];

const STAR_ELEM: Record<number, string> = { 1: '水', 2: '土', 3: '木', 4: '木', 5: '土', 6: '金', 7: '金', 8: '土', 9: '火' };
const GEN: Record<string, string> = { 水: '木', 木: '火', 火: '土', 土: '金', 金: '水' };

// 方角に回っている星から、場所の種類を決める
const STAR_PLACE: Record<number, string> = {
  1: '温泉や水辺',
  2: '畑や広い公園など、ひらけた自然',
  3: '音楽の流れる場所や、新しいお店',
  4: '風の通る高原や木立',
  6: '神社やお寺、高台',
  7: '静かな喫茶店や食事処',
  8: '山や見晴らしのいい場所',
  9: '美術館や明るい街なか',
};

export type NearbyResult =
  | { kind: 'ok'; direction: string; place: string; star: number; relation: '生気' | '比和' | '退気' }
  | { kind: 'none' };

/**
 * 日盤の星の並びと本命星から、今日の近場の吉方位を1つ選ぶ。
 * 五黄殺・暗剣殺・本命殺・本命的殺・日破を除き、本命星を生む星（生気）> 同じ気（比和）> 本命星が生む星（退気）の順。
 */
export function getNearbyLuckyDirection(dayStars: number[], honmei: number, dayBranchIdx: number): NearbyResult {
  const bad = new Set<number>();
  const add = (p: number) => { if (p >= 0 && p !== 4) { bad.add(p); if (OPP[p] !== undefined) bad.add(OPP[p]); } };
  add(dayStars.indexOf(5));         // 五黄殺・暗剣殺
  add(dayStars.indexOf(honmei));    // 本命殺・本命的殺
  bad.add(OPP[BRANCH_POS[dayBranchIdx]]); // 日破（日の十二支の反対）

  const he = STAR_ELEM[honmei];
  const rank = (s: number): number => {
    const se = STAR_ELEM[s];
    if (GEN[se] === he) return 0;
    if (se === he) return 1;
    if (GEN[he] === se) return 2;
    return -1;
  };

  let best: { pos: number; r: number } | null = null;
  for (let p = 0; p < 9; p++) {
    if (p === 4 || bad.has(p)) continue;
    const s = dayStars[p];
    if (s === 5) continue;
    const r = rank(s);
    if (r < 0) continue;
    if (!best || r < best.r) best = { pos: p, r };
  }
  if (!best) return { kind: 'none' };
  const star = dayStars[best.pos];
  return { kind: 'ok', direction: POS_DIR[best.pos], place: STAR_PLACE[star], star, relation: (['生気', '比和', '退気'] as const)[best.r] };
}

// 行った場所の種類（記録用）
export const PLACE_TYPES = ['温泉', '水辺', '自然・公園', '神社・お寺', '喫茶店', '食事処', '山・高台', '美術館', '街なか', 'その他'];
export const MOODS = ['すっきり', 'ほっとした', 'わくわく', 'ふつう', 'つかれた'];
